<template>
  <div class="contenedor">
    <div class="title">
      {{valores.descripcion}}
    </div>
    <div class="container">
      <div class="de">
        <div class="den">
          <div class="dene">
            <div class="denem">
              <div class="deneme">
                {{ valores.temp.temperatura.toString().split(".")[0] }}<span
                  v-if="decimales">.{{ valores.temp.temperatura.toString().split(".")[1] }}</span><strong>&deg;</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <a :href= panelid target="_blank"><img  class="imgchart" src="../assets/chart.png" v-if="!modoctrl"/></a>

    <!-- <iframe :src= panelid width="80%" height="200" frameborder="0">
    </iframe> -->
    <br>
    <img class="imgthermo" :src = logo v-if="!modoctrl" />

    <div class="radio" v-if="modoctrl">
          <input label="Ventilador" type="radio" id="vent" name="gender" value="vent" v-model="modo" v-on:click="clikmodo('vent')" >
          <input label="Frio" type="radio" id="frio" name="gender" value="frio" v-model="modo" v-on:click="clikmodo('frio')" >
          <input label="Calor" type="radio" id="calor" name="gender" v-model="modo" value="calor" v-on:click="clikmodo('calor')">
          <input label="Auto" type="radio" id="auto" name="gender" v-model="modo" value="auto" v-on:click="clikmodo('auto')">
    </div>

      <div class="titulo" v-if="modoctrl">Consigna</div>
      <div class="input-group">
        <input type="button" value="-" class="button-minus" v-on:click="clikconsigna('-')">
        <input type="number" step="1" max="30" v-model="consigna" class="quantity-field">
        <input type="button" value="+" class="button-plus" v-on:click="clikconsigna('+')">
      </div>

    <label v-if="reles1" class="switch-light switch-candy ancho1">
      <input type="checkbox" v-model="btn1" v-on:click="clikbtn(1)" />



      <span>
        <span>Apagar</span>
        <span>Encender</span>
        <a></a>
      </span>
    </label>
    <label v-if="reles2" class="switch-light switch-candy ancho1">
      <input type="checkbox" v-model="btn2" v-on:click="clikbtn(2)" />

      Rele2

      <span>
        <span>Apagar</span>
        <span>Encender</span>
        <a></a>
      </span>
    </label>

  </div>
</template>

<script>
  import firebase from "firebase";

  export default {
    name: "ThermoCompo",
    props: {
      ThermoD: String
    },
    data() {
      return {
        panelid: String,
        logo: String,
        btn1: Boolean,
        btn2: Boolean,
        device: String,
        temperature: String,
        reles1: false,
        reles2: false,
        modo:0,
        consigna:0,
        modoctrl:false,
        decimales: Boolean,
        valores: {
          temp: {
            temperatura: '0.0'
          },
          descripcion: ''
        }
      };
    },

    methods: {
      clikconsigna: function(event){
        switch (event) {
          case '+':
            if (this.consigna <31)
              this.consigna +=1
            break;
          case '-':
            if (this.consigna >14)
              this.consigna -=1
            break;
          default:
            break;
        }
        firebase
        .database()
        .ref("devices/" + this.ThermoD + "/reles/consigna")
        .set(this.consigna*10);
      },
      clikmodo: function(event){
        switch (event) {
              case 'vent':
                this.modo= 'vent'
                firebase
                .database()
                .ref("devices/" + this.ThermoD + "/reles/modo")
                .set(0);
                break;
              case 'frio':
                firebase
                .database()
                .ref("devices/" + this.ThermoD + "/reles/modo")
                .set(1);
                break;
              case 'calor':
                firebase
                .database()
                .ref("devices/" + this.ThermoD + "/reles/modo")
                .set(2);
                break;
              case 'auto':
                firebase
                .database()
                .ref("devices/" + this.ThermoD + "/reles/modo")
                .set(3);
                break;

              default:
                break;
            }
      },
      clikbtn: function (event) {
        if (event == 1) {
          this.btn1 = !this.btn1;
          if (this.btn1)
            firebase
            .database()
            .ref("devices/" + this.ThermoD + "/reles/a")
            .set(1);
          else
            firebase
            .database()
            .ref("devices/" + this.ThermoD + "/reles/a")
            .set(0);
        } else {
          this.btn2 = !this.btn2;
          if (this.btn2)
            firebase
            .database()
            .ref("devices/" + this.ThermoD + "/reles/b")
            .set(1);
          else
            firebase
            .database()
            .ref("devices/" + this.ThermoD + "/reles/b")
            .set(0);
        }
      }
    },
     created(){
      let url2 = "devices/" + this.ThermoD + "/reles/";
      firebase.database().ref(url2).on("value", snapshot => {
          this.valores = snapshot.val();

          this.panelid = "http://134.209.228.254:3000/d/tBGELfsZk/new-dashboard-copy?tab=advanced&orgId=1&fullscreen&edit&panelId=" + this.valores.panelid
          this.logo = this.valores.logo

          //console.log(this.valores.descripcion)
          if ((this.valores.temp.temperatura.toString().split(".")[1] != '0')&& (this.valores.temp.temperatura.toString().split(".")[1])){
            this.decimales = true
          }
          else
            this.decimales = false
          console.log(this.valores.a)
          console.log(this.valores.b)
          this.valores.a == 1 ? (this.btn1 = true) : (this.btn1 = false);
          this.valores.b == 1 ? (this.btn2 = true) : (this.btn2 = false);
          this.consigna = this.valores.consigna/10
          if (this.valores.tipo == 'rele'){
            if (this.valores.a==0 || this.valores.a == 1)
              this.reles1 = true
            if (this.valores.b==0 || this.valores.b == 1)
              this.reles2 = true
          }
          else {
            this.reles1 = false
            this.reles2 = false
          }
          if (this.valores.modo == 0 || this.valores.modo == 1 || this.valores.modo == 2 || this.valores.modo == 3){
            this.modo = this.valores.modo
            this.modoctrl = true
            switch (this.valores.modo) {
              case 0:
                this.modo= 'vent'
                break;
              case 1:
                this.modo= 'frio'
                break;
              case 2:
                this.modo= 'calor'
                break;
              case 3:
                this.modo= 'auto'
                break;

              default:
                break;
            }

          }
          else {
            this.modoctrl = false

          }
        });
    },
    async beforeCreate() {

    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html {
    min-height: 100% !important;
  }

  body {
    background: #505050 -moz-radial-gradient(top, #cdcdcf 0%, #505050 70%) no-repeat 50% 0%;
    background: #505050 radial-gradient(top, #cdcdcf 0%, #505050 70%) no-repeat 50% 0%;
    height: 100%;
  }
  .switch-light > span {
    position: relative;
    max-width: 50%;
    overflow: hidden;
    display: block;
    min-height: 2em;
    padding: 0;
    text-align: center;
    margin: 0 auto;
    font-size: x-small;
}
  .contenedor{
    border: #505050;
    padding: 4px;
    border-style: solid;
    border-width: 1px;

  }
  .ancho1{
    width: 240px;
    margin: 20px auto 0;
  }
  .imgchart{
    position:sticky;
    width: 25px;
    top:30px;
    right: 30px;

  }
  .title {
    top: 44%;
    width: 100%;
    position: relative;
    left: 0;
    right: 0;
    margin: 10px auto 15px;
  }

  @import url(https://fonts.googleapis.com/css?family=Dosis:200,400,500,600);

  html,
  body {
    height: 100%;
  }

  body {
    background: #f2f2f2;
  }
  .titulo{
    text-align: center;
    padding-top: 10px;
  }
  .container {
    width: 230px;
    margin: 20px auto 0;
  }

  .de .den,
  .de .dene,
  .de .denem,
  .de .deneme {
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .de {
    position: relative;
    width: 240px;
    height: 240px;
    border-radius: 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    background-color: transparent;
  }

  .den {
    position: relative;
    width: 210px;
    height: 210px;
    margin: -105px 0 0 -105px;
    border-radius: 100%;
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, .5), 0 2px 20px rgba(255, 255, 255, 1);
    background: #df3341;
    background: -moz-linear-gradient(left, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    background: -webkit-gradient(linear, left top, right top, color-stop(0%, #df3341), color-stop(50%, #d4f355), color-stop(100%, #61c0ec));
    background: -webkit-linear-gradient(left, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    background: linear-gradient(to right, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    position: relative;
  }

  .dene {
    width: 180px;
    height: 180px;
    margin: -90px 0 0 -90px;
    border-radius: 100%;
    box-shadow: inset 0 2px 2px rgba(255, 255, 255, .4), 0 3px 13px rgba(0, 0, 0, .85);
    background: #f2f6f5;
    background: -moz-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #f2f6f5), color-stop(100%, #cbd5d6));
    background: -webkit-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
    background: -o-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
  }

  .denem {
    width: 160px;
    height: 160px;
    margin: -80px 0 0 -80px;
    border-radius: 100%;
    background: #cbd5d6;
    background: -moz-linear-gradient(top, #cbd5d6 0%, #f2f6f5 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #cbd5d6), color-stop(100%, #f2f6f5));
    background: -webkit-linear-gradient(top, #cbd5d6 0%, #f2f6f5 100%);
  }

  .deneme {
    padding: 3px 10px 0 10px;
    width: 120px;
    height: 137px;
    display: inline-block;
    margin: -70px 0 0 -70px;
    color: #555;
    text-shadow: 1px 1px 1px white;
    font-family: 'Dosis';
    font-size: 100px;
    font-weight: 400;
    text-align: center;
  }

  .deneme span {
    font-size: 30px;
    font-weight: 200;
  }

  .deneme strong {
    position: absolute;
    right: 10px;
    top: 25px;
    font-size: 34px;
  }
  .wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  grid-auto-rows: minmax(100px, auto);
  padding: 10px;
}
.one {
  padding: 15px;
  border-radius: 10px;
  grid-column: 1/ 2;
  grid-row: 1;
  background-color: rgb(184, 178, 178);;
}
.two {
  padding: 15px;
  border-radius: 10px;
  grid-column: 2/ 2;
  grid-row: 1 ;
  background-color: rgb(184, 178, 178);
}
.radio {
	background: #454857;
	padding: 4px;
	border-radius: 3px;
	box-shadow: inset 0 0 0 3px rgba(35, 33, 45, 0.3),
		0 0 0 3px rgba(185, 185, 185, 0.3);
	position: relative;
}

.radio input {
	width: auto;
	height: 100%;
	appearance: none;
	outline: none;
	cursor: pointer;
	border-radius: 2px;
	padding: 4px 8px;
	background: #454857;
	color: #bdbdbdbd;
	font-size: 14px;
	font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
		"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
		"Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
	transition: all 100ms linear;
}

.radio input:checked {
	background-image: linear-gradient(180deg, #95d891, #74bbad);
	color: #fff;
	box-shadow: 0 1px 1px #0000002e;
	text-shadow: 0 1px 0px #79485f7a;
}

.radio input:before {
	content: attr(label);
	display: inline-block;
	text-align: center;
	width: 100%;
}
input,
textarea {
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  margin: 0;
  outline: none;
  padding: 10px;
}

input[type="button"] {
  -webkit-appearance: button;
  cursor: pointer;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.input-group {
  clear: both;
  margin: 5px 0;
  position: relative;
}

.input-group input[type='button'] {
  background-color: #eeeeee;
  min-width: 38px;
  width: auto;
  transition: all 300ms ease;
}

.input-group .button-minus,
.input-group .button-plus {
  font-weight: bold;
  height: 38px;
  padding: 0;
  width: 38px;
  position: relative;
}

.input-group .quantity-field {
  position: relative;
  height: 38px;
  left: -6px;
  text-align: center;
  width: 62px;
  display: inline-block;
  font-size: 13px;
  margin: 0 0 5px;
  resize: vertical;
}

.button-plus {
  left: -13px;
}

input[type="number"] {
  -moz-appearance: textfield;
  -webkit-appearance: none;
}


</style>